/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phone/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Preference from './Preference/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Phone({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/ViewDetails/Content/Phones/Phone"
  
}) {
let editRelationPhoneNumberValueData = fromData.useDataFormat({ viewPath,
context: 'edit_relation_phone',
path: 'number',
format: fromFormat.phoneNumberUS,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let editRelationPhoneDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'edit_relation_phone',
path: 'description',
})
let aggregateData = fromAggregate.getValueOrDefault(editRelationPhoneDescriptionValueData)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Phone.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Phone.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 data="edit_relation_phone.number"
 format="/Data/format.js phoneNumberUS"
 text={editRelationPhoneNumberValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 paddingBottom={dtSpaceXxs}
 size="small"
 color={dtColorsNeutral500}
 data="edit_relation_phone.description"
 aggregate="/Data/aggregate.js getValueOrDefault"
 text={aggregateData}
/>
</div>
<Preference
  viewPath={`${viewPath}/Preference`}
/>
</div>
{children}
</React.Fragment>)
}